<template>
    <form @submit.prevent="on_submit" id="submit_form">
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <label for="merchant_type" v-text="$t('label.merchant_type')"></label>
                <select :disabled="!form_data.is_editable"
                        @change="initSelectPicker()"
                        class="form-control kt-selectpicker"
                        id="merchant_type"
                        name="merchant_type"
                        v-model="form_data.merchant_type">
                    <option :value="merchant_type.REAL" v-text="merchant_type_str.get(merchant_type.REAL)"></option>
                    <option :value="merchant_type.LEGAL" v-text="merchant_type_str.get(merchant_type.LEGAL)"></option>
                </select>
            </div>
        </div>
        <hr>
        <div class="row my-4">

            <template v-if="form_data.merchant_type == merchant_type.REAL">
                <div class="col-12 col-md-6 my-2">
                    <label for="first_name_fa" v-text="$t('label.first_name_fa')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="first_name_fa"
                           name="first_name_fa"
                           type="text"
                           v-model="form_data.first_name_fa">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="first_name_en" v-text="$t('label.first_name_en')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="first_name_en"
                           name="first_name_en"
                           type="text"
                           v-model="form_data.first_name_en">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="last_name_fa" v-text="$t('label.last_name_fa')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="last_name_fa"
                           name="last_name_fa"
                           type="text"
                           v-model="form_data.last_name_fa">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="last_name_en" v-text="$t('label.last_name_en')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="last_name_en"
                           name="last_name_en"
                           type="text"
                           v-model="form_data.last_name_en">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="father_name_fa" v-text="$t('label.father_name_fa')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="father_name_fa"
                           name="father_name_fa"
                           type="text"
                           v-model="form_data.father_name_fa">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="father_name_en" v-text="$t('label.father_name_en')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="father_name_en"
                           name="father_name_en"
                           type="text"
                           v-model="form_data.father_name_en">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="gender" v-text="$t('label.gender')"></label>
                    <select :disabled="!form_data.is_editable"
                            class="form-control custom-select"
                            id="gender"
                            name="gender"
                            v-model="form_data.gender">
                        <option :value="gender_types.FEMALE"
                                v-text="gender_types_str.get(gender_types.FEMALE)"></option>
                        <option :value="gender_types.MALE" v-text="gender_types_str.get(gender_types.MALE)"></option>
                    </select>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="birth_date" v-text="$t('label.birth_date')"></label>
                    <datePicker
                            :disabled="!form_data.is_editable"
                            display-format="dddd jDD jMMMM jYYYY"
                            format="YYYY-MM-DD HH:mm:ss"
                            id="birth_date"
                            input-class="form-control"
                            name="birth_date"
                            type="date"
                            v-model="form_data.birth_date">
                    </datePicker>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="national_code" v-text="$t('label.national_code')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="national_code"
                           name="national_code"
                           type="text"
                           v-model="form_data.national_code">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="birth_crtfct_number" v-text="$t('label.birth_crtfct_number')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="birth_crtfct_number"
                           name="birth_crtfct_number"
                           type="text"
                           v-model="form_data.birth_crtfct_number">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="birth_crtfct_serial" v-text="$t('label.birth_crtfct_serial')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="birth_crtfct_serial"
                           name="birth_crtfct_serial"
                           type="text"
                           v-model="form_data.birth_crtfct_serial">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="birth_crtfct_series_letter" v-text="$t('label.birth_crtfct_series_letter')"></label>
                    <select :disabled="!form_data.is_editable"
                            class="form-control custom-select"
                            id="birth_crtfct_series_letter"
                            name="birth_crtfct_series_letter"
                            v-model="form_data.birth_crtfct_series_letter">
                        <option
                                :key="index"
                                :value="letter.key"
                                v-for="(letter, index) in birth_crtfct_series_letters"
                                v-text="letter.value"
                        >
                        </option>
                    </select>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="birth_crtfct_series_number" v-text="$t('label.birth_crtfct_series_number')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="birth_crtfct_series_number"
                           name="birth_crtfct_series_number"
                           type="text"
                           v-model="form_data.birth_crtfct_series_number">
                </div>
            </template>

            <template v-else-if="form_data.merchant_type == merchant_type.LEGAL">
                <div class="col-12 my-3">
                    <div class="h5">
                        <i class="text-primary fas fa-file-signature"></i>
                        <span class="px-2">{{ $t('legal_user.label.signature_holder_info') }}</span>
                    </div>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_first_name_fa">
                        {{ $t('label.first_name') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" id="signature_holder_first_name_fa"
                           name="signature_holder_first_name_fa" type="text"
                           v-model="form_data.signature_holder.first_name_fa">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_first_name_en">
                        {{ $t('label.first_name_en') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" dir="ltr"
                           id="signature_holder_first_name_en"
                           name="signature_holder_first_name_en" type="text"
                           v-model="form_data.signature_holder.first_name_en">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_last_name_fa">
                        {{ $t('label.last_name') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" id="signature_holder_last_name_fa"
                           name="signature_holder_last_name_fa" type="text"
                           v-model="form_data.signature_holder.last_name_fa">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_last_name_en">
                        {{ $t('label.last_name_en') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" dir="ltr"
                           id="signature_holder_last_name_en"
                           name="signature_holder_last_name_en" type="text"
                           v-model="form_data.signature_holder.last_name_en">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_father_name_fa">
                        {{ $t('label.father_name') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" id="signature_holder_father_name_fa"
                           name="signature_holder_father_name_fa" type="text"
                           v-model="form_data.signature_holder.father_name_fa">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_father_name_en">
                        {{ $t('label.father_name_en') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" dir="ltr"
                           id="signature_holder_father_name_en"
                           name="signature_holder_father_name_en" type="text"
                           v-model="form_data.signature_holder.father_name_en">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_birth_date">
                        {{ $t('label.birth_date') }}
                    </label>
                    <datePicker
                            :disabled="!form_data.is_editable"
                            display-format="dddd jDD jMMMM jYYYY"
                            format="YYYY-MM-DD HH:mm:ss"
                            id="signature_holder_birth_date"
                            input-class="form-control"
                            name="signature_holder_birth_date"
                            type="date"
                            v-model="form_data.signature_holder.birth_date"/>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="signature_holder_national_code">
                        {{ $t('label.national_code') }}
                    </label>
                    <input :disabled="!form_data.is_editable" class="form-control" dir="ltr"
                           id="signature_holder_national_code" maxlength="10"
                           name="signature_holder_national_code" type="text"
                           v-model="form_data.signature_holder.national_code">
                </div>

                <div class="col-12 mt-5 mb-3">
                    <div class="h5">
                        <i class="text-primary far fa-building"></i>
                        <span class="px-2">{{ $t('legal_user.label.company_info') }}</span>
                    </div>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="com_name_fa" v-text="$t('label.com_name_fa')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="com_name_fa"
                           name="com_name_fa"
                           type="text"
                           v-model="form_data.com_name_fa">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="com_name_en" v-text="$t('label.com_name_en')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="com_name_en"
                           name="com_name_en"
                           type="text"
                           v-model="form_data.com_name_en">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="register_date" v-text="$t('label.com_register_date')"></label>
                    <datePicker
                            :disabled="!form_data.is_editable"
                            display-format="dddd jDD jMMMM jYYYY"
                            format="YYYY-MM-DD HH:mm:ss"
                            id="register_date"
                            input-class="form-control"
                            name="register_date"
                            type="date"
                            v-model="form_data.register_date">
                    </datePicker>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="register_number" v-text="$t('label.register_number')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="register_number"
                           name="register_number"
                           type="text"
                           v-model="form_data.register_number">
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="national_legal_code" v-text="$t('label.national_legal_code')"></label>
                    <input :disabled="!form_data.is_editable"
                           class="form-control"
                           id="national_legal_code"
                           name="national_legal_code"
                           type="text"
                           v-model="form_data.national_legal_code">
                </div>
            </template>

            <div class="col-12 col-md-6 my-2">
                <label for="telephone_number" v-text="$t('label.telephone')"></label>
                <input :disabled="!form_data.is_editable"
                       class="form-control"
                       id="telephone_number"
                       name="telephone_number"
                       type="text"
                       v-model="form_data.telephone_number">
            </div>

            <div class="col-12 col-md-6 my-2">
                <label for="cellphone_number" v-text="$t('label.phone')"></label>
                <input :disabled="!form_data.is_editable"
                       class="form-control"
                       id="cellphone_number"
                       name="cellphone_number"
                       type="text"
                       v-model="form_data.cellphone_number">
            </div>

            <div class="col-12 col-md-6 my-2">
                <label for="email_address">
                    <span v-text="$t('label.email')"></span>&nbsp;
                    <span class="text-muted" style="font-size: .8rem" v-text="$t('label.optional')"></span>
                </label>
                <input :disabled="!form_data.is_editable"
                       class="form-control"
                       id="email_address"
                       name="email_address"
                       type="text"
                       v-model="form_data.email_address">
            </div>
        </div>

        <hr>

        <div class="row my-4">
            <div class="col-12 col-md-6 my-2">
                <label>
                    <span v-text="$t('label.sheba_numbers')"></span>&nbsp;
                    <span @click="add_sheba_number_input()" class="text-success" style="cursor: pointer !important;"
                          v-text="$t('btn.add')"></span>
                </label>
                <div :key="index" class="my-2" v-for="index in sheba_numbers_length">
                    <div class="input-group" dir="ltr">
                        <div class="input-group-prepend">
                            <span class="input-group-text">IR</span>
                        </div>
                        <input :class="['form-control sheba_number_inputs', form_meta_data.invalid_sheba_numbers.includes(index -1) ? 'invalid-sheba-number-input': '']"
                               :disabled="!form_data.is_editable"
                               :id="'sheba_number_' + index"
                               :name="'sheba_number_' + index"
                               dir="ltr"
                               type="text"
                               v-model="form_data.iban[index -1]">
                        <div @click="removeSheba(index - 1)" class="text-danger p-1"
                             style="position: absolute; right: 6px; top: 6px; cursor: pointer;"
                             v-text="$t('btn.delete')"></div>
                    </div>
                </div>
            </div>
            <div class="col-12 my-2 text-danger" v-if="form_meta_data.invalid_sheba_numbers.length > 0">
            <span>
                <i class="fas fa-exclamation-triangle"></i>
                <span class="mx-2" v-text="$t('stakeholders.error.invalid_sheba_numbers')"></span>
            </span>
            </div>
        </div>

        <div class="my-4" v-if="form_data.is_editable">
            <button :disabled="form_meta_data.submit_btn_progress"
                    class="btn btn-success"
                    type="submit"
            >
                <div class="d-flex align-items-center">
                    <div v-text="form_meta_data.submit_btn_text"></div>
                    <div class="ml-2 spinner-border spinner-border-sm" role="status"
                         v-if="form_meta_data.submit_btn_progress"></div>
                </div>
            </button>
        </div>
    </form>
</template>

<script>
    import $ from 'jquery';
    import {i18n} from '@/plugins/i18n';
    import {merchantType, merchantTypeStr} from '@/constants/merchantType';
    import {genderTypes, genderTypesStr} from '@/constants/genderTypes';
    import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter';
    import Inputmask from 'inputmask';
    import IranSheba from 'iran-sheba';

    export default {
        data() {
            return {
                sheba_number_input_count: 1,
                merchant_type: merchantType,
                merchant_type_str: merchantTypeStr,
                gender_types: genderTypes,
                gender_types_str: genderTypesStr,
                birth_crtfct_series_letters: birthCrtfctSeriesLetters,
            }
        },
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                        invalid_sheba_numbers: [],
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        computed: {
            sheba_numbers_length() {
                if (this.form_data.iban.length > 0) {
                    return this.form_data.iban.length;
                }

                return this.sheba_number_input_count;
            },
            get_sheba_numbers() {
                return this.form_data.iban;
            },
        },
        watch: {
            get_sheba_numbers() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 1000);
            },
        },
        methods: {
            add_sheba_number_input() {
                if (this.form_data.iban.length > 0) {
                    this.form_data.iban.push('');
                } else {
                    ++this.sheba_number_input_count;
                }

                this.recheck_invalid_sheba();
            },
            removeSheba(index) {
                if (this.sheba_numbers_length > 1) {
                    if (this.form_data.iban.length > 0) {
                        this.form_data.iban.splice(index, 1);
                    } else {
                        --this.sheba_number_input_count;
                    }
                } else {
                    this.form_data.iban[index] = '';
                    $('#sheba_number_1').val('');
                }

                this.recheck_invalid_sheba();
            },
            recheck_invalid_sheba() {
                this.form_meta_data.invalid_sheba_numbers = [];

                for (let i = 0; i < this.sheba_numbers_length; ++i) {
                    let value = this.form_data.iban[i];

                    if (value == '') {
                        continue;
                    }

                    let sheba = 'IR' + value.split('-').join('');

                    if (!IranSheba.isValid(sheba)) {
                        this.form_meta_data.invalid_sheba_numbers.push(i);
                    }
                }
            },
            initSelectPicker() {
                setTimeout(() => {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    });
                }, 1000);
            },
            initShebaMask() {
                Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.sheba_number_inputs'));
            },
        },
        mounted() {
            this.initSelectPicker();
            this.initShebaMask();
        },
    }
</script>

<style>
    .invalid-sheba-number-input {
        border: 1px red solid !important;
    }
</style>
